<template>
  <span v-html="highlightedContent" />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { escapeHtml, renderAlgoliaHighlight } from '@/utils/highlight';

interface Props {
  content: string;
  highlightResult?: {
    value: string;
    matchLevel: string;
    matchedWords: string[];
  };
}

const props = defineProps<Props>();

// Esto se renderiza con v-html: tanto el fallback como el resaltado de
// Algolia traen el contenido del registro SIN escapar (un campo con HTML
// — tecleado o extraído por IA de un documento externo — ejecutaba aquí)
const highlightedContent = computed(() => {
  if (!props.highlightResult || props.highlightResult.matchLevel === 'none') {
    return escapeHtml(props.content);
  }
  return renderAlgoliaHighlight(props.highlightResult.value);
});
</script>

<style scoped>
:deep(em) {
  font-style: normal;
  font-weight: 600;
  @apply bg-primary-100 dark:bg-primary-900/30 text-primary-900 dark:text-primary-100 px-0.5 rounded;
}
</style>
